// extracted by mini-css-extract-plugin
export default {"container":"DocumentEditorWrapper_container__FHeLn","editor":"DocumentEditorWrapper_editor__rI42F"};